import { useSetPageSubtitle } from '@/app/store';
import { Heading, Text } from '@chakra-ui/react';

export const ShowNotificationDetails = () => {
  useSetPageSubtitle('Program - 1 Job');

  return (
    <div>
      <Text>
        <Heading>Program - 1 Job Status</Heading>
        <Text>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis
          dignissim pretium nibh, ac lacinia odio commodo ut. Nullam nec
          pellentesque tellus. Aliquam aliquam dolor eget tortor aliquam, quis
          sodales urna maximus. Integer vitae neque nec lorem cursus
          consectetur. Donec semper, elit quis laoreet eleifend, orci purus
          interdum erat, a rutrum mi lorem ac mi. Vestibulum et rutrum enim. Nam
          erat erat, finibus ut nisi sed, ullamcorper ornare augue. Nunc ornare
          eu tortor tempus varius. Morbi pretium, magna sed accumsan gravida,
          nunc leo consequat arcu, vel rutrum sapien tellus id dui.
          <Text fontWeight='bold'>
            Cras in sapien venenatis, commodo metus ut, faucibus erat.
          </Text>
          Integer non justo ligula. Quisque commodo tellus ac tortor posuere,
          eget scelerisque eros gravida. Mauris eu sagittis sem. Vivamus
          lobortis, dui at condimentum consectetur, nulla dui gravida nibh, ac
          ornare mauris ligula in libero. Quisque ac est non mi euismod ultrices
          et in odio. Sed tincidunt ut mauris in ornare.
        </Text>
        <Text>
          Class aptent taciti sociosqu ad litora torquent per conubia nostra,
          per inceptos himenaeos. Aenean at aliquet quam, et sollicitudin
          lectus. Mauris lacinia at velit eu venenatis. Morbi ac facilisis
          felis, viverra congue ex. Nullam cursus quis lacus at molestie. Aenean
          consequat blandit lectus in consequat. Mauris bibendum eget quam vel
          scelerisque. Sed in ligula odio. Quisque viverra lacus mauris, ut
          ornare justo malesuada a. Duis vel rhoncus leo. Fusce ut leo massa.
          Donec faucibus sed nunc in pretium. Praesent eleifend sed dui vitae
          tempus. Fusce malesuada ultricies tortor, quis imperdiet ex dictum sit
          amet. Quisque vitae rhoncus massa. Nunc ultricies convallis lobortis.
        </Text>
      </Text>
    </div>
  );
};
